<template lang="pug">
v-dialog(v-model="show", persistent, max-width="50%")
    v-card(v-if="fatura")
        v-card-title
            v-flex.md8.title {{ title }}
            v-flex.md4.text-xs-right
              v-btn(flat, @click="close()", density="comfortable", icon="", variant="plain")
                v-icon close
        v-card-text
            template
                h4.pt-3(style="font-size: 18px; color:#1113128A; font-weight:500") Cálculo do total bruto com pagamento online
                div(style="background-color:#FAFAFA; border-radius:8px").pa-3.mt-4.mb-4
                    v-layout(row,wrap).pb-4
                        v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                            label <strong>  {{(fatura.indicadores ? fatura.indicadores.quantidadePedidosPgtOnline : 0)}} vendas </strong> com pagamento online confirmadas
                            br
                            span(v-if="estabelecimentoSelecionado && !estabelecimentoSelecionado.cardapio_digital")
                              small(style="font-size:16px; color:#1113128A" v-if="fatura.indicadores && fatura.comissao_subsidio && !fatura.indicadores.quantidadeTaxaServicoPgtOnline")
                                | (incluindo: {{fatura.indicadores.quantidadeDescontosPgtOnline}} cupons + {{fatura.indicadores.quantidadeReembolsosPromocionaisPgtOnline}} subsídios)
                              small(style="font-size:16px; color:#1113128A" v-if="fatura.indicadores && fatura.comissao_subsidio && fatura.indicadores.quantidadeTaxaServicoPgtOnline")
                                | (incluindo: {{fatura.indicadores.quantidadeDescontosPgtOnline}} cupons + {{fatura.indicadores.quantidadeReembolsosPromocionaisPgtOnline}} subsídios + {{fatura.indicadores.quantidadeTaxaServicoPgtOnline}} taxas de serviço)
                              small(style="font-size:16px; color:#1113128A" v-if="!fatura.comissao_subsidio")
                                | (incluindo: {{fatura.indicadores.quantidadeDescontosPgtOnline}} cupons)
                            span(v-if="estabelecimentoSelecionado && estabelecimentoSelecionado.cardapio_digital && fatura.indicadores.quantidadeTaxaServicoPgtOnline")
                                | (incluindo: {{fatura.indicadores.quantidadeTaxaServicoPgtOnline}} taxas de serviço)
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                            strong + {{(fatura.indicadores ? (fatura.indicadores.totalVendasPgtOnline + fatura.indicadores.totalTaxaServicoPgtOnline) : 0) | currency}}

                div(style="border:1px solid; border-radius:8px; color:#0000000A", v-if="fatura.indicadores.quantidadeTaxaServico").pt-3.pb-3.mb-3.mt-3.pl-3
                    v-layout(row,wrap)
                      v-flex.md8.xs12(style="font-size:18px; color:#000")
                        strong Total bruto de {{fatura.indicadores.quantidadePedidosPgtOnline}} vendas com pagamento online
                      v-flex.md4.xs12.text-md-right.pr-3(style="font-size:18px; color:#111312CC")
                        strong {{ (fatura.indicadores.totalVendasPgtOnline + fatura.indicadores.totalTaxaServicoPgtOnline) | currency }}

                div(style="border:1px solid; border-radius:8px; color:#0000000A", v-if="fatura.indicadores.quantidadeTaxaServicoPgtOnline").pt-3.pb-3.mb-3.mt-3.pl-3
                    v-layout(row,wrap)
                      v-flex.md8.xs12(style="font-size:18px; color:#000")
                        label <strong>Taxa de serviço de {{(fatura.indicadores ? fatura.indicadores.quantidadeTaxaServicoPgtOnline : 0)}} vendas confirmadas </strong>
                      v-flex.md4.xs12.text-md-right.pr-3(style="font-size:18px; color:#111312CC")
                        strong - {{ (fatura.indicadores ? fatura.indicadores.totalTaxaServicoPgtOnline : 0) | currency }}

                div(style="border:1px solid; border-radius:8px; color:#0000000A").pa-3.mt-4.mb-4
                    v-layout(row, wrap)
                        v-flex.md8.xs12(style="font-size:18px; color:#111312")
                            strong Base de cálculo da taxa de {{ tipo == taxaPagamentoOnline ? 'pagamento online' : 'antecipação' }}
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#111312CC")
                            strong {{ (fatura.indicadores ? fatura.indicadores.totalVendasPgtOnline : 0) | currency }}

                div(style="border:1px solid; border-radius:8px; color:#0000000A", v-if="tipo == taxaPagamentoOnline").pa-3.mt-4.mb-4
                    v-layout(row,wrap)
                        v-flex.md8.xs12(style="font-size:18px; color:#111312")
                            strong Taxa de pagamento online
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#111312CC")
                            strong {{(fatura.indicadores ? fatura.indicadores.totalTaxasPgtOnline : 0) | currency}}
                div(style="border:1px solid; border-radius:8px; color:#0000000A", v-if="tipo == taxaAntecipacao").pa-3.mt-4.mb-4
                    v-layout(row,wrap)
                        v-flex.md8.xs12(style="font-size:18px; color:#111312")
                            strong Taxa de antecipação
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#111312CC")
                            strong {{(fatura.indicadores ? fatura.totalTaxaAntecipacao : 0) | currency}}
                div(style="border:1px solid; border-radius:8px; color:#0000000A", v-if="tipo == taxaAntecipacao").pa-3.mt-4.mb-4
                    v-layout(row,wrap)
                        v-flex.md12.xs12(style="font-size:18px; color:#111312").text-md-center
                            small(style="font-size:16px; color:#1113128A") A opção de antecipação está à sua disposição, e a taxa correspondente será aplicada somente se a antecipação for solicitada por você
        v-card-actions.mr-4.pb-3
            v-spacer
            v-btn(flat,@click="close()") Fechar

</template>

<script>

export default {
  props: {

  },
  data () {
    return {
        show : false,
        fatura : null,
        taxaAntecipacao : 'antecipacao',
        taxaPagamentoOnline : 'pgtonline',
        tipo : null,
        title: '',
        titles: {
            'antecipacao' : 'Taxa de Antecipação',
            'pgtonline' : 'Taxa de Pagamento Online'
        },
    }
  },
  created () {

  },
  watch: {
  },
  computed: {
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
  },
  methods: {
    open(fatura, tipo){
        const vm = this;
        vm.fatura = fatura;
        vm.show = true;
        vm.tipo = tipo || 'pgtonline'
        vm.title = vm.titles[tipo]
    },
    close(){
        const vm = this;
        vm.fatura = null;
        vm.show = false;
    }
  }
}
</script>
